import axios from 'axios';
import { auth } from '@/services/firebase';

import { baseURL } from '@/config';

const request = axios.create({
  baseURL,
});

const getAuthorizationToken = () => new Promise((resolve) => {
  const user = auth.currentUser;

  if (!user) {
    resolve(null);
  } else {
    const promise = user.getIdToken();

    promise
      .then(resolve)
      .catch(() => {
        resolve(null);
      });
  }
});

request.interceptors.request.use(async (config) => {
  config.withCredentials = true;
  const token = await getAuthorizationToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default request;
